import * as React from "react"
import * as _ from "lodash"
import { CardModalNotOkButton } from "../../modal"
import * as Model from "../../../model"
import AccountModalPresenter, { Names } from "./account-modal-presenter"

class AccountModal extends React.Component<AccountModalProps, State> {
	constructor(props) {
		super(props)
		this.state = {
			applyToLocalAuthorities: [],
			newAccount: this.copyAccount(props.account)
		}
	}

	componentWillReceiveProps(props: AccountModalProps) {
		const newAccount: Model.Account = this.copyAccount(props.account)
		this.setState({ newAccount })
	}

	render() {
		return <AccountModalPresenter
		account={this.state.newAccount}
		chapters={this.props.chapters}
		classes={this.props.classes}
		instruction={this.props.instruction}
		loading={this.props.loading}
		localAuthorities={this.props.localAuthorities}
		onChange={e => this.handleChange(e) }
		onClickCloseButton={this.props.onClickCloseButton}
		onClickFooterButton={(button, e) => this.handleClickFooterButton(button, e)}
		onSubmit={e => this.props.onSubmit(this.props.account, this.state.newAccount, this.state.applyToLocalAuthorities, e)} />
	}

	private copyAccount(account: Model.Account): Model.Account {
		return account
			? _.clone(account)
			: {
					addedOn: null,
					class: this.props.classes[0],
					defaultChapter: null,
					expense: true,
					id: null,
					label: "",
					number: "",
					operation: true,
					receipts: true,
					removedOn: null,
					template: true,
				}
	}

	private handleChange(e: React.SyntheticEvent<Element>) {
		const target = e.target as HTMLElement
		const account = this.state.newAccount
		const applyToLocalAuthorities: Model.LocalAuthority[] = []

		if (this.isHTMLInputElement(target)) {
			switch (target.name) {
				case Names.Expense:
					account.expense = target.checked
					break;
				case Names.Label:
					account.label = target.value
					break;
				case Names.Number:
					account.number = target.value
					break;
				case Names.Operation:
					account.operation = "1" === target.value
					break;
				case Names.Receipts:
					account.receipts = target.checked
					break;
				case Names.Template:
					account.template = target.checked
					break;
			}
		} else if(this.isHTMLSelectElement(target)) {
			switch (target.name) {
				case Names.Class:
					account.class = this.props.classes.find(cl => cl.id === parseInt(target.value))
					break;
				case Names.DefaultChapter:
					account.defaultChapter = this.props.chapters.find(ch => ch.id === parseInt(target.value))
					break;
				case Names.ApplyToLocalAuthorities:
					const options = target.options
					for (let i = 0; i < options.length; i++) {
						if (!options[i].selected) continue
						const localAuthority = this.props.localAuthorities.find(l => l.id === parseInt(options[i].value))
						if (localAuthority) applyToLocalAuthorities.push(localAuthority)
					}
					break;
			}
		}

		this.setState({ applyToLocalAuthorities, newAccount: account })
	}

	private handleClickFooterButton(button: CardModalNotOkButton, e: React.SyntheticEvent<Element>): void {
		this.props.onClickCloseButton(e)
	}

	private isHTMLInputElement(element: HTMLElement): element is HTMLInputElement {
		return "INPUT" === element.tagName.toLocaleUpperCase()
	}

	private isHTMLSelectElement(element: HTMLElement): element is HTMLSelectElement {
		return "SELECT" === element.tagName.toLocaleUpperCase()
	}
}

export default AccountModal

export interface AccountModalProps {
	account?: Model.Account
	chapters: Model.Chapter[]
	classes: Model.Class[]
	instruction: Model.Instruction
	loading: boolean
	localAuthorities: Model.LocalAuthority[]
	onClickCloseButton(e: React.SyntheticEvent<Element>): void
	onSubmit(
		originalAccount: Model.Account,
		newAccount: Model.Account,
		applyToLocalAuthorities: Model.LocalAuthority[],
		e: React.SyntheticEvent<Element>
	): void
}

interface State {
	applyToLocalAuthorities: Model.LocalAuthority[]
	newAccount: Model.Account
}



// WEBPACK FOOTER //
// ./src/component/instructions/account-modal/index.tsx